import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.accounting.rules');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-accounting-rules',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.accounting.rules/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAccountingRulesComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public rules: any[] = [];
    public showModal: boolean = false;
    public editMode: boolean = false;
    public editId: string = '';
    public filterType: string = '';
    public typeOptions = ['category', 'member', 'allocation'];
    public txTypeOptions = ['fee', 'expense', 'refund', 'settlement', 'transfer', 'other'];
    public categoryOptions = ['food', 'activity', 'supplies', 'operation', 'other'];
    public allocModeOptions = ['equal', 'participants', 'ratio', 'fixed', 'exclude'];
    public form: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        let res = await wiz.call("list", { type: this.filterType });
        if (res.code === 200) this.rules = res.data || [];
        await this.service.render();
    }

    public async filterByType(type: string) {
        this.filterType = type === this.filterType ? '' : type;
        await this.load();
    }

    public openCreate() {
        this.editMode = false;
        this.form = { type: 'category', keyword: '', tx_type: '', category: '', subcategory: '', allocation_mode: '', target_members: '', priority: 0 };
        this.showModal = true;
        this.service.render();
    }

    public openEdit(rule: any) {
        this.editMode = true;
        this.editId = rule.id;
        this.form = { ...rule };
        try { this.form.target_members = JSON.parse(rule.target_members || '[]').join(', '); } catch { this.form.target_members = ''; }
        this.showModal = true;
        this.service.render();
    }

    public closeModal() {
        this.showModal = false;
        this.service.render();
    }

    public async save() {
        let data: any = { ...this.form };
        if (data.target_members) {
            data.target_members = JSON.stringify(data.target_members.split(',').map((s: string) => s.trim()).filter((s: string) => s));
        } else {
            data.target_members = '[]';
        }
        let res;
        if (this.editMode) {
            data.id = this.editId;
            res = await wiz.call("update", data);
        } else {
            res = await wiz.call("create", data);
        }
        if (res.code === 200) {
            this.showModal = false;
            await this.load();
        } else {
            await this.service.modal.show({ title: '오류', message: res.data?.message || '저장 실패' });
        }
        await this.service.render();
    }

    public async remove(rule: any) {
        let res = await this.service.modal.show({ title: '규칙 삭제', message: `"${rule.keyword}" 규칙을 삭제하시겠습니까?`, action: '삭제', status: 'error' });
        if (!res) return;
        await wiz.call("delete", { id: rule.id });
        await this.load();
    }

    public typeLabel(type: string) {
        return { category: '카테고리', member: '멤버', allocation: '분배' }[type] || type;
    }
}

export default PageAccountingRulesComponent;